import React, {Component} from 'react';
import SimpleSelect from 'components/atoms/dropdowns/simple-select';

class PlayersQuantity extends Component {
    render() {
        const {range} = this.props;
        const options = {};

        range.map((item) => (options[item] = item));

        return (
            <SimpleSelect
                className="form-control input-sm"
                value={this.props.value}
                options={options}
                onChange={this.props.onChange}
            />
        );
    }
}

export default PlayersQuantity;
